<template>
    <div>
        <task-ended
            v-if="form.status === 'Done' && !forceEditView"
            :task-prop="form.data()"
            :is-view-for-modal="isViewForModal"
            :task-permissions="permissions"
            @forceEdit="state => forceEditView = state"
        />
        <form v-else @submit.prevent="onSubmit()" @input="form.$errors.clear($event.target.name);">
            <placeholder-form :loading="form.loading()">
                <data-card :header-responsive="false" :footer-responsive="false" :remove-class="isViewForModal">
                    <!-- Formularz -->
                    <template #default>
                        <div :class="`row justify-content-${isViewForModal ? 'center' : 'between'}`" ref="taskFormRef">
                            <div :class="{'col-md-6': !isViewForModal}">
                                <div class="card card-body bg-light mb-3">
                                    <h3><i :class="checklistIcon"></i> <b>{{ form.title }}</b></h3>
                                    <h4><b>{{ $t('[[[Informacje podstawowe]]]') }}</b></h4>
                                    <!-- Nieruchomosc -->
                                    <ideo-form-group v-if="isDeletedType" :label="$t('[[[Nieruchomość]]]')">
                                        <ideo-form-input v-model="deletedForm.property.name" type="text" name="propertyName" :disabled="true"></ideo-form-input>
                                    </ideo-form-group>
                                    <template v-else>
                                        <ideo-form-group :label="$t('[[[Zadanie na nieruchomościach roboczych]]]')">
                                            <ideo-form-checkbox v-model="isCustomProperty" :disabled="!!publicId" :switch="true" class="ml-3" />
                                        </ideo-form-group>
                                        <ideo-form-group v-show="isCustomProperty" :label="$t('[[[Nieruchomość robocza]]]')" :invalid-feedback="form.$errors.first('customPropertyPublicId')" :state="form.$errors.state('customPropertyPublicId')" required>
                                            <ideo-autocomplete
                                                v-model="form.customPropertyPublicId"
                                                name="propertyPublicId"
                                                track-by="publicId"
                                                :placeholder="$t('[[[Zacznij pisać aby wyszukać nieruchomość roboczą...]]]')"
                                                :fetch="(customPropertyPublicId) => fetchCustomProperty(customPropertyPublicId)"
                                                :search="(query, limit) => searchCustomProperty(query, limit)"
                                                :disabled="isEditMode"
                                            >
                                                <template #selected="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ml-2">{{ option.propertyName }}</b>
                                                        <i class="ml-auto">{{ option.city }}</i>
                                                    </div>
                                                </template>
                                                <template #option="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ml-2">{{ option.propertyName }}</b>
                                                        <i class="ml-auto">{{ option.city }}</i>
                                                    </div>
                                                </template>
                                            </ideo-autocomplete>
                                        </ideo-form-group>
                                        <ideo-form-group v-show="!isCustomProperty" :label="$t('[[[Nieruchomość]]]')" :invalid-feedback="form.$errors.first('propertyPublicId')" :state="form.$errors.state('propertyPublicId')" required>
                                            <ideo-autocomplete
                                                v-model="form.propertyPublicId"
                                                name="propertyPublicId"
                                                track-by="publicId"
                                                :placeholder="$t('[[[Zacznij pisać aby wyszukać nieruchomość...]]]')"
                                                :fetch="(publicId) => fetchPropertyV2(publicId)"
                                                :search="(query, limit) => searchPropertyV2(query, limit)"
                                                :disabled="isEditMode"
                                            >
                                                <template #selected="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ml-2">{{ option.propertyName }}</b>
                                                        <i class="ml-auto">{{ option.city }}</i>
                                                    </div>
                                                </template>
                                                <template #option="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ml-2">{{ option.propertyName }}</b>
                                                        <i class="ml-auto">{{ option.city }}</i>
                                                    </div>
                                                </template>
                                            </ideo-autocomplete>
                                        </ideo-form-group>
                                    </template>
                                    <!-- End Nieruchomosc -->
                                    <!-- Wydzial -->
                                    <ideo-form-group v-if="isDeletedType" :label="$t('[[[Wydział]]]')">
                                        <ideo-form-input v-model="deletedForm.department" type="text" :disabled="true"></ideo-form-input>
                                    </ideo-form-group>
                                    <ideo-form-group v-else :label="$t('[[[Wydział]]]')" :invalid-feedback="form.$errors.first('department')" :state="form.$errors.state('department')" required>
                                        <ideo-form-select name="department" v-model="form.department" :options="departmentOptions" value-field="value" text-field="text">
                                            <template #first>
                                                <option :value="null || ''">{{ $t('Brak wydziału') }}</option>
                                            </template>
                                        </ideo-form-select>
                                    </ideo-form-group>
                                    <!-- End Wydzial -->
                                    <!-- Dostep -->
                                    <div v-if="isCustomProperty && customPropertyAccessNote" class="card bg-light mb-4">
                                        <div class="card-body">
                                            <ideo-form-group :label="$t('[[[Dane dostępowe:  ]]]')">
                                                <br />
                                                <span>{{ customPropertyAccessNote }} </span>
                                            </ideo-form-group>
                                        </div>
                                    </div>
                                    <ideo-form-group v-else v-show="propertyNote" :label="$t('[[[Dostęp]]]')">
                                        <ideo-form-textarea v-model="propertyNote" name="access" disabled></ideo-form-textarea>
                                    </ideo-form-group>
                                    <!-- End Dostep -->
                                    <!-- Status -->
                                    <div class="d-flex flex-column mb-2">
                                        <span>{{ $t('[[[Status: ]]]') }}</span>
                                        <span class="fw-bold">{{ isDeletedType ? deletedForm.status : status }}</span>
                                    </div>
                                    <!-- End Status -->
                                    <!-- Created By -->
                                    <div v-if="form.createdByUserFullName || deletedForm.createdByUser" class="d-flex flex-column mb-2">
                                        <span>{{ $t('[[[Utworzono przez: ]]]') }}</span>
                                        <span class="fw-bold">{{ form.createdByUserFullName ?? `${deletedForm.createdByUser.givenName} ${deletedForm.createdByUser.surname}` }}</span>
                                    </div>
                                    <!-- End Created by -->
                                    <!-- Deleted By (deleted form) -->
                                    <div v-if="deletedForm.deletedByUser" class="d-flex flex-column mb-2">
                                        <span>{{ $t('[[[Usunięto przez: ]]]') }}</span>
                                        <span class="fw-bold">{{ `${deletedForm.deletedByUser.givenName} ${deletedForm.deletedByUser.surname}` }}</span>
                                    </div>
                                    <!-- End Deleted by -->
                                    <!-- Completed By (deleted form) -->
                                    <div v-if="deletedForm.completedByUser" class="d-flex flex-column mb-2">
                                        <span>{{ $t('[[[Zakończone przez: ]]]') }}</span>
                                        <span class="fw-bold">{{ `${deletedForm.completedByUser.givenName} ${deletedForm.completedByUser.surname}` }}</span>
                                    </div>
                                    <!-- End Completed by -->
                                    <div v-show="isRestFormVisible">
                                        <h4><b>{{ $t('[[[Dane zadania]]]') }}</b></h4>
                                        <!-- Priorytet -->
                                        <ideo-form-group v-if="isDeletedType" :label="$t('[[[Priorytet]]]')">
                                            <ideo-form-input v-model="deletedForm.priority" type="text" :disabled="true"></ideo-form-input>
                                        </ideo-form-group>
                                        <ideo-form-group v-else :label="$t('[[[Priorytet]]]')" :invalid-feedback="form.$errors.first('priority')" :state="form.$errors.state('priority')">
                                            <ideo-form-radio-group v-model="form.priority" :options="priorityOptions" name="priority" @change="onPriorityChange"></ideo-form-radio-group>
                                        </ideo-form-group>
                                        <!-- Priorytet End -->
                                        <!-- CheckList -->
                                        <ideo-form-group v-if="isDeletedType" :label="$t('[[[Szablon checklisty]]]')">
                                            <ideo-form-input v-model="deletedForm.checklist.name" type="text" :disabled="true"></ideo-form-input>
                                        </ideo-form-group>
                                        <ideo-form-group :disabled="isCustomProperty" :label="$t('[[[Szablon checklisty]]]')" :invalid-feedback="form.$errors.first('templateChecklistPublicId')" :state="form.$errors.state('templateChecklistPublicId')" :required="isDepartment('Cleaning') && !isCustomProperty">
                                            <ideo-autocomplete
                                                v-model="form.templateChecklistPublicId"
                                                name="templateChecklistPublicId"
                                                track-by="publicId"
                                                :placeholder="$t('[[[Zacznij pisać aby wyszukać szablon checklisty...]]]')"
                                                :disabled="isCustomProperty"
                                                :fetch="(publicId) => fetchChecklist(publicId)"
                                                :search="(query, limit) => searchChecklist(query, limit, form.department, propertyCityId)"
                                            >
                                                <template #selected="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ml-2">{{ option.name }}</b>
                                                    </div>
                                                </template>
                                                <template #option="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ml-2">{{ option.name }}</b>
                                                    </div>
                                                </template>
                                            </ideo-autocomplete>
                                        </ideo-form-group>
                                        <!-- End checklist -->

                                        <!-- Activities (replaces the old free-text task name — HIR-137 redesign) -->
                                        <ideo-form-group v-if="isDeletedType" :label="$t('[[[Nazwa zadania]]]')">
                                            <ideo-form-input v-model="deletedForm.title" type="text" :disabled="true"></ideo-form-input>
                                        </ideo-form-group>
                                        <ideo-form-group v-else :label="$t('[[[Dodaj czynność]]]')" :invalid-feedback="form.$errors.first('title')" :state="form.$errors.state('title')" required>
                                            <task-activity-picker
                                                :model-value="form.activities || []"
                                                @update:model-value="onActivitiesChanged"
                                                :department="form.department"
                                                :disabled="!permissions.canEdit"
                                                :placeholder="$t('[[[Zacznij pisać aby wyszukać czynność...]]]')"
                                            />
                                        </ideo-form-group>
                                        <!-- End activities -->
                                        <!-- Bok (only displayed if BOK tag is selected) -->
                                        <ul v-if="bokSelected && !isDeletedType" class="bok-template">
                                            <li>{{ $t('[[[co się wydarzyło]]]') }}</li>
                                            <li>
                                                {{ $t('[[[co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)]]]') }}
                                            </li>
                                            <li>
                                                {{ $t('[[[kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)]]]') }}
                                            </li>
                                            <li>
                                                {{ $t('[[[jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji]]]') }}
                                            </li>
                                        </ul>
                                        <!-- End bok -->
                                        <!-- Opis -->
                                        <ideo-form-group v-if="isDeletedType" :label="$t('[[[Opis]]]')">
                                            <ideo-form-input v-model="deletedForm.description" type="text" :disabled="true"></ideo-form-input>
                                        </ideo-form-group>
                                        <ideo-form-group v-else :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('description')" :state="form.$errors.state('description')">
                                            <ideo-form-textarea v-model="form.description" name="description" rows="2" :placeholder="$t('[[[Dodaj opis...]]]')"></ideo-form-textarea>
                                        </ideo-form-group>
                                        <!-- End Opis -->
                                        <!-- dueDate -->
                                        <ideo-form-group v-if="isDeletedType" :label="$t('[[[Data wykonania]]]')">
                                            <ideo-datetime
                                                name="dueDate"
                                                v-model="deletedForm.dueDateUtc"
                                                type="datetime"
                                                :disabled="true"
                                            />
                                        </ideo-form-group>
                                        <ideo-form-group v-else :label="$t('[[[Data wykonania]]]')" :invalid-feedback="form.$errors.first('dueDate')" :state="form.$errors.state('dueDate')" :required="isDepartment('CustomerService')">
                                            <ideo-datetime
                                                name="dueDate"
                                                v-model="form.dueDate"
                                                type="datetime"
                                                :minute-step="15"
                                                :days-with-task="daysWithTask"
                                                :days-with-reservations="daysWithReservations"
                                            />
                                        </ideo-form-group>
                                        <!-- endDue date -->
                                        <!-- Actual Working Time -->
                                        <div class="row">
                                            <ideo-form-group :label="$t('[[[Faktyczny czas pracy]]]')" class="col-12 col-md-3" :invalid-feedback="form.$errors.first('actualWorkingTime')" :state="form.$errors.state('actualWorkingTime')">
                                                <input
                                                    type="hidden"
                                                    v-model="form.actualWorkingTime"
                                                    name="actualWorkingTime"
                                                />
                                                <ideo-form-input
                                                    v-model="form.actualWorkingTimeDisplay"
                                                    type="time"
                                                    name="actualWorkingTimeDisplay"
                                                    :disabled="!permissions.canEditPropActualWorkingTime"
                                                ></ideo-form-input>
                                            </ideo-form-group>
                                        </div>
                                        <!-- End Actual Working Time -->
                                        <!-- Assigned users -->
                                        <div v-if="isRestFormVisible">
                                            <ideo-form-group v-if="isDeletedType" :label="$t('[[[Przypisane do:]]]')">
                                                <div class="alert alert-dark" v-if="!deletedForm.assignedUsers.length">
                                                    {{ $t('[[[Brak przypisanych użytkowników.]]]') }}
                                                </div>
                                                <div v-else class="row">
                                                    <div class="col">
                                                        <ul class="list-group list-group-flush">
                                                            <li class="list-group-item bg-light" v-for="(item) in deletedForm.assignedUsers" :key="item.id.toString()">
                                                                <div class="d-flex flex-nowrap align-items-center">
                                                                    <i class="fas fa-user"></i>
                                                                    <b class="ml-2">{{ item.givenName }} {{ item.surname }}</b>
                                                                    <i class="ml-auto">{{ item.email }}</i>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </ideo-form-group>
                                            <renter-assign-user v-else name="assignedUsersIds" :show-add-all="true" :show-all-records="true" v-model="form.assignedUsersIds" :init-assigned-users="defaultUsers" :user-department="form.department" :property-public-id="form.propertyPublicId" track-by="id" @onLoading="(loading) => loading ? form.wait() : form.continue()" :able-to-assigne-user-outside-current-district="true" />
                                        </div>
                                        <!-- end Assigned users -->
                                        <!-- Assignment sub-panel intentionally removed in the HIR-137 redesign — activities
                                             now live in the multiselect picker above. The backend endpoints under
                                             /taskActivityAssignments are still live (see stakeholder decision, Aug 2026)
                                             so any external caller/report keeps working. -->
                                        <div v-if="form.templateChecklistPublicId && !isDeletedType" class="d-flex justify-content-center">
                                            <router-link :to="{ name: 'renter-checklists-edit', params: { publicId: form.templateChecklistPublicId } }">
                                                <ideo-button>{{ $t('[[[Przejdź do Checklisty]]]') }}</ideo-button>
                                            </router-link>
                                        </div>
                                        <!-- Chats -->
                                        <div class="d-flex justify-content-center mt-2">
                                            <ideo-button
                                                v-if="form.publicId && !isDeletedType && !form.taskChats.length"
                                                @click="$router.push({ name: 'chat-add-from-task', params: { taskPublicId: form.publicId } })"
                                            >
                                                {{ $t('[[[Stwórz czat]]]') }}
                                            </ideo-button>
                                            <ideo-button
                                                v-if="form.taskChats.length"
                                                @click="chatsVisible = !chatsVisible"
                                            >
                                                {{ chatsVisible ? $t('[[[Ukryj czat]]]') : $t('[[[Pokaż czat]]]') }}
                                            </ideo-button>
                                        </div>
                                        <renter-chats-list :chats-visible="chatsVisible" :list="form.taskChats" />
                                        <chat-view
                                            v-if="currentChatPublicId"
                                            :chat-public-id="currentChatPublicId"
                                            @chatClosed="currentChatPublicId = ''"
                                        />
                                        <!-- End Chats -->
                                        <!-- Notes -->
                                        <notes-from-task v-if="isDeletedType" :notes="deletedForm.createdNotes" :is-disabled="true" />
                                        <notes-from-task v-else-if="publicId" :parent-task-public-id="publicId" />
                                        <!-- End Notes -->
                                        <!-- Comment -->
                                        <div v-if="!isDeletedType && publicId" class="mt-4">
                                            <h4><b>{{ $t('[[[Notatka/Komentarz]]]') }}</b></h4>
                                            <ideo-form-group :label="$t('[[[Dodaj notatkę/komentarz]]]')" :invalid-feedback="commentError" :state="commentError ? false : null">
                                                <ideo-form-textarea
                                                    v-model="form.comment"
                                                    name="comment"
                                                    rows="3"
                                                    :placeholder="$t('[[[Wpisz komentarz...]]]')"
                                                    @input="commentError = null"
                                                ></ideo-form-textarea>
                                            </ideo-form-group>
                                            <ideo-button
                                                @click="saveComment"
                                                :disabled="savingComment || !form.active()"
                                                variant="primary"
                                            >
                                                <i v-if="savingComment" class="fas fa-spinner fa-spin me-1"></i>
                                                {{ $t('[[[Zapisz komentarz]]]') }}
                                            </ideo-button>
                                        </div>
                                    <!-- End Comment -->
                                    </div>
                                </div>
                            </div>
                            <div :class="{'col-md-6': !isViewForModal}" v-if="isRestFormVisible">
                                <div class="card card-body bg-light mb-3">
                                    <div class="d-flex justify-content-between" v-if="isViewForModal">
                                        <h4><b>{{ $t('[[[Szczegóły zadania]]]') }}</b></h4>
                                        <ideo-button @click="() => collapseSection('details')">{{ collapse.details ? $t('[[[-]]]') : $t('[[[+]]]') }}</ideo-button>
                                    </div>
                                    <div v-show="isViewForModal ? collapse.details : true">
                                        <!-- Tags -->
                                        <ideo-form-group v-if="isDeletedType" :label="$t('[[[Tagi:]]]')">
                                            <div class="alert alert-dark" v-if="!deletedForm.tags.length">
                                                {{ $t('[[[Brak przypisanych tagów.]]]') }}
                                            </div>
                                            <div v-else class="row">
                                                <div class="col">
                                                    <ul class="list-group list-group-flush">
                                                        <li class="list-group-item bg-light" v-for="(item) in deletedForm.tags" :key="item.publicId.toString()">
                                                            <div class="d-flex flex-nowrap align-items-center">
                                                                <i class="fas fa-user"></i>
                                                                <b class="ml-2">{{ item.name }}</b>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </ideo-form-group>
                                        <FormTasksTags v-else :key="form.tagsIds" v-model="form.tagsIds" name="tagsIds" track-by="id" @onLoading="(loading) => loading ? form.wait() : form.continue()" :watch-b-o-k="true" @watchBOK="onBOKselected" />
                                        <!-- End Tags -->
                                        <!-- Photos -->
                                        <ideo-form-group :label="$t('[[[Załączone zdjęcia]]]')" :invalid-feedback="form.$errors.first('photos')" :state="form.$errors.state('photos')" class="mb-0">
                                            <fileupload v-if="isDeletedType" v-model="deletedForm.photos" :disabled="true"></fileupload>
                                            <fileupload v-else v-model="form.photos" :max-files="50" :accept="['image/jpeg', 'image/png']"></fileupload>
                                        </ideo-form-group>
                                        <!-- Photos -->
                                        <!-- Wager -->
                                        <div v-if="isWagerAvailable && !isDeletedType">
                                            <h4><b>{{ $t('[[[Wynagrodzenie]]]') }}</b></h4>
                                            <ideo-form-group v-if="!isCustomProperty && !!property?.cleaningWage" :label="getCorrectLabel" :invalid-feedback="form.$errors.first('additionalWageAmount')" :state="form.$errors.state('additionalWageAmount')">
                                                <ideo-form-input v-model="property.cleaningWage" type="number" name="additionalWageAmount" min="0" :disabled="true" />
                                            </ideo-form-group>
                                            <ideo-form-group :label="$t('[[[Dodatkowe wynagrodzenie - kwota]]]')" :invalid-feedback="form.$errors.first('additionalWageAmount')" :state="form.$errors.state('additionalWageAmount')">
                                                <ideo-form-input v-model="form.additionalWageAmount" type="text" name="additionalWageAmount" />
                                            </ideo-form-group>
                                            <ideo-form-group :label="$t('[[[Dodatkowe wynagrodzenie - komentarz]]]')" :invalid-feedback="form.$errors.first('additionalWageComment')" :state="form.$errors.state('additionalWageComment')">
                                                <ideo-form-textarea v-model="form.additionalWageComment" name="additionalWageComment" rows="2" :placeholder="$t('[[[Dodaj opis...]]]')"></ideo-form-textarea>
                                            </ideo-form-group>
                                            <div v-if="!isCustomProperty && !!property?.cleaningWage" class="mb-2">
                                                <span class="d-block mb-1">{{ $t('[[[Ostateczne wynagrodzenie:]]]') }}</span>
                                                <span><strong>{{ getTotalWage }} PLN</strong></span>
                                            </div>
                                        </div>
                                        <!-- End Wager -->
                                        <!-- Powiadomienie o zmianach -->
                                        <ideo-form-group v-if="!isDeletedType" :label="$t('[[[Powiadomienie o zmianach]]]')">
                                            <ideo-form-select v-model="form.requestedByDepartment" name="requestedBy" :options="groups">
                                                <template #first>
                                                    <option :value="null">{{ $t('Nie wybrano') }}</option>
                                                </template>
                                            </ideo-form-select>
                                        </ideo-form-group>
                                        <!-- End Powiadomienie o zmianach -->
                                        <!-- Numer rezerwacji -->
                                        <ideo-form-group v-if="isDeletedType && deletedForm.reservation" :label="$t('[[[Rezerwacja]]]')">
                                            <div class="d-flex flex-nowrap align-items-center justify-content-between">
                                                <b>{{ deletedForm.reservation.clientName }} {{ deletedForm.reservation.clientSurname }}</b>
                                                <span>{{ deletedForm.reservation.guestyId }}</span>
                                            </div>
                                        </ideo-form-group>
                                        <ideo-form-group v-else-if="!isCustomProperty && !isDeletedType" :label="$t('[[[Numer rezerwacji]]]')" :invalid-feedback="form.$errors.first('reservationPublicId')" :state="form.$errors.state('reservationPublicId')" :required="isDepartment('CustomerService')">
                                            <ideo-autocomplete
                                                v-model="form.reservationPublicId"
                                                name="reservationPublicId"
                                                track-by="publicId"
                                                :placeholder="$t('[[[Zacznij pisać numer aby wyszukać rezerwację...]]]')"
                                                :fetch="(publicId) => fetchReservation(publicId)"
                                                :search="(query, limit) => searchReservation(query, limit, form.propertyPublicId)"
                                            >
                                                <template #selected="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ms-2">{{ option.clientName }} {{ option.clientSurname }}</b>
                                                        <i class="ms-auto">{{ option.avantioLocalizator || '-' }}</i>
                                                    </div>
                                                </template>
                                                <template #option="{ option }">
                                                    <div class="d-flex flex-nowrap align-items-center">
                                                        <b class="ms-2">{{ option.clientName }} {{ option.clientSurname }}</b>
                                                        <i class="ms-auto">{{ option.avantioLocalizator || '-' }}</i>
                                                    </div>
                                                </template>
                                            </ideo-autocomplete>
                                            <div class="my-2" v-if="reservationDates">
                                                <span class="d-block mb-1">{{ $t('[[[Szczegóły rezerwacji]]]') }}:</span>
                                                <p>{{ `${$t('[[[Pobyt: ]]]')} ${reservationDates}` }}</p>
                                            </div>
                                            <div class="mt-2 d-flex flex-column gap-2">
                                                <ideo-button v-if="form.reservationPublicId" :to="{ name: 'renter-reservations-details', params: { publicId: form.reservationPublicId }}">{{ $t('[[[Przejdź do rezerwacji]]]') }}</ideo-button>
                                                <ideo-button v-if="form.reservationPublicId && clipboardAvailable() && reservationNumber" @click="copyToClipboard(reservationNumber)">{{ $t('[[[Kopiuj numer rezerwacji]]]') }}</ideo-button>
                                            </div>
                                        </ideo-form-group>

                                        <!-- Recenzja gościa -->
                                        <div v-if="form.guestReview" class="card mt-3">
                                            <div class="card-header d-flex align-items-center">
                                                <i class="fas fa-star me-2 text-warning"></i>
                                                <strong>{{ $t('[[[Recenzja gościa]]]') }}</strong>
                                            </div>
                                            <div class="card-body">
                                                <div v-if="form.guestReview.reviewerName" class="mb-2">
                                                    <span class="text-muted small">{{ $t('[[[Gość]]]') }}: </span>
                                                    <span>{{ form.guestReview.reviewerName }}</span>
                                                </div>
                                                <div v-if="form.guestReview.submittedAtUtc" class="mb-2">
                                                    <span class="text-muted small">{{ $t('[[[Data recenzji]]]') }}: </span>
                                                    <span>{{ formatReviewDate(form.guestReview.submittedAtUtc) }}</span>
                                                </div>
                                                <div v-if="form.guestReview.channel" class="mb-2">
                                                    <span class="text-muted small">{{ $t('[[[Kanał]]]') }}: </span>
                                                    <span class="badge" :class="channelBadgeClass(form.guestReview.channel)">{{ channelLabel(form.guestReview.channel) }}</span>
                                                </div>
                                                <div v-if="form.guestReview.cleanlinessRating != null" class="mb-2">
                                                    <span class="text-muted small me-1">{{ $t('[[[Ocena czystości]]]') }}: </span>
                                                    <star-rating :value="form.guestReview.cleanlinessRating" :max="form.guestReview.maxRating" />
                                                </div>
                                                <div v-if="form.guestReview.overallRating != null" class="mb-2">
                                                    <span class="text-muted small me-1">{{ $t('[[[Ocena ogólna]]]') }}: </span>
                                                    <star-rating :value="form.guestReview.overallRating" :max="form.guestReview.maxRating" />
                                                </div>
                                                <div v-if="form.guestReview.publicReview" class="mt-2">
                                                    <span class="text-muted small d-block mb-1">{{ $t('[[[Treść recenzji]]]') }}:</span>
                                                    <p class="mb-0 fst-italic">{{ form.guestReview.publicReview }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End recenzja gościa -->

                                        <ideo-button
                                            v-if="permissions.canViewChangeLog"
                                            @click="showTaskHistory"
                                            variant="secondary"
                                            class="w-100"
                                        >
                                            <i class="fas fa-history me-1"></i>
                                            {{ $t('[[[Historia zmian]]]') }}
                                        </ideo-button>
                                    <!-- End numer rezerwacji -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- Footer -->
                    <template #footer>
                        <action-bar :toggle-footer="true" v-if="!isViewForModal" class="action-buttons-container">
                            <action-button v-if="!isDeletedType" toolbar variant="success" icon="far fa-check-circle" :text="$t('[[[Zapisz]]]')" @click="onSubmit('back')" :disabled="!form.active() || !permissions.canEdit" />
                            <action-button v-if="!isDeletedType" toolbar submit variant="primary" icon="fas fa-check" :text="$t('[[[Zastosuj]]]')" :disabled="!form.active() || !permissions.canEdit" />
                            <action-button v-if="!isDeletedType" :v-show="!isDeletedType" :confirm="$t('[[[Potwierdzenie usunięcia]]]')" @click="handleClickDeleteTask" toolbar variant="outline-danger" icon="fa-solid fa-trash" :text="$t('[[[Usuń zadanie]]]')" :disabled="!form.active() || !permissions.canEdit" />
                            <action-button v-if="isTaskNotClosed && !isDeletedType" @click="handleClickCloseTask" toolbar variant="secondary" icon="fa-solid fa-check-to-slot" :text="$t('[[[Zamknij]]]')" :disabled="!form.active() || !permissions.canEdit" />
                            <action-button back variant="outline-dark" icon="far fa-arrow-alt-circle-left" :text="$t('[[[Powrót]]]')" @click.stop="goBack" />
                        </action-bar>
                        <div class="modal-footer-buttons" v-else>
                            <ideo-button v-if="!isDeletedType" @click="openAddCost">
                                {{ $t('[[[Dodaj koszt]]]') }}
                            </ideo-button>
                            <action-button v-if="!isDeletedType" toolbar variant="success" icon="far fa-check-circle" :text="$t('[[[Zapisz]]]')" @click="onSubmit('back')" :disabled="!form.active() || !permissions.canEdit" />
                        </div>
                    </template>
                </data-card>
            </placeholder-form>
        </form>
        <ideo-modal
            ref="routesModal"
            :title="$t('[[[Zadanie na trasie]]]')"
            size="md"
            @close="closeRoutesModal"
        >
            <p>{{ $t('[[[To zadanie dotyczy nieruchomości, która znajduje się na trasie. Czy chcesz przejść do mapy, aby edytować punkt?]]]') }}</p>
            <div v-if="taskRoutesInfo && taskRoutesInfo.routeNames.length > 0" class="mt-3">
                <p class="mb-2"><strong>{{ $t('[[[Zadanie znajduje się na trasach:]]]') }}</strong></p>
                <ul>
                    <li v-for="(routeName, index) in taskRoutesInfo.routeNames" :key="index">{{ routeName }}</li>
                </ul>
            </div>
            <p class="mt-3 text-muted"><small>{{ $t('[[[Po przejściu na mapę zadanie zostanie usunięte.]]]') }}</small></p>
            <template #modal-footer>
                <action-button
                    variant="secondary"
                    @click="closeRoutesModal"
                    :text="$t('[[[Nie]]]')"
                    icon="far fa-ban"
                />
                <action-button
                    variant="primary"
                    @click="confirmDeleteWithRoutes"
                    :disabled="deletingTask"
                    :loading="deletingTask"
                    :text="$t('[[[Tak, przejdź do mapy]]]')"
                    icon="fa-solid fa-map"
                />
            </template>
        </ideo-modal>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from '@/helpers/Decorators';
import { Form, FormType } from '@/helpers/Form';
import { Option } from '@/helpers/Interfaces';
import { Resource } from '@/modules/core/files/services/StorageService';
import { DepartmentEnum as DepartmentEnumUsers, DepartmentOptions as UserDepartmentOptions } from '@/modules/core/users/services/UsersService';
import ChatView from '@/modules/renter/chat/components/ChatView.vue';
import RenterChatsList from '@/modules/renter/chat/components/RenterChatsList.vue';
import { StatusEnum as ChatStatusEnum } from '@/modules/renter/chat/services/ChatService';
import { fetchChecklist, fetchCustomProperty, fetchProperty, fetchPropertyV2, fetchReservation, searchChecklist, searchCustomProperty, searchProperty, searchPropertyV2, searchReservation } from '@/modules/renter/common/helpers/autocomplete';
import RenterAssignUser from '@/modules/renter/components/RenterAssignUser.vue';
import TaskActivityPicker, { ActivityChip } from '@/modules/renter/components/TaskActivityPicker.vue';
import NotesFromTask from '@/modules/renter/notes/components/NotesFromTask.vue';
import PropertiesService, { FormModel as PropertyFormModel } from '@/modules/renter/properties/services/PropertiesService';
import StarRating from '@/modules/renter/salaries/components/StarRating.vue';
import TaskActivityAssignmentsService from '@/modules/renter/taskActivityAssignments/services/TaskActivityAssignmentsService';
import TasksService, { DateCalendarEmitProps, DeletedFormModel, DepartmentEnum, DepartmentOptions, FormModel, PriorityEnum, PriorityOptions, ReservationsObject, StatusEnum, StatusName, TaskMetaPermissions, TaskRoutesModel, TasksObject, UserItemModel } from '@/modules/renter/tasks/services/TasksService';
import TasksTagsService, { TaskTagName } from '@/modules/renter/tasksTags/services/TasksTagsService';
import { DateTime } from 'luxon';
import { Options, Vue, setup } from 'vue-class-component';
import { useRouter } from 'vue-router';
import TaskIcon from '../../components/elements/TaskIcon';
import FormTasksTags from '../components/FormTaskTags.vue';
import { useAnnualStocktakeTag } from '../composables/useAnnualStocktakeTag';
import { useTaskCreatedAlert } from '../composables/useTaskCreatedAlert';
import TaskEnded from './TaskEnded.vue';

@Options({
    emits: ['close', 'taskCreated'],
    components: { TaskEnded, RenterChatsList, ChatView, NotesFromTask, RenterAssignUser, FormTasksTags, StarRating, TaskActivityPicker }
})
export default class TaskForm extends Vue
{
    @Prop({ default: false }) public fromModal: boolean;
    @Prop({ default: null }) public publicIdProvided: string;
    @Prop({ default: null }) public propertyProvided: string;
    @Prop({ default: null }) public reservationProvided: string;
    @Prop({ default: null }) public descriptionProvided: string;
    @Prop({ default: null }) public dateProvided: any;
    @Prop({ default: null }) public departmentProvided: string;
    @Prop({ default: null }) public photosProvided: Array<Resource>;
    @Prop({ default: '' }) public taskTitle: string;

    public collapse: any = { details: false };

    public forceEditView: boolean = false;
    public bokSelected: boolean = false;
    private annualStocktakeTag = setup(() => useAnnualStocktakeTag());
    private taskCreatedAlert = setup(() => useTaskCreatedAlert(useRouter()));
    public propertyCityId: number = null;
    public property: PropertyFormModel = null;
    public propertyNote: string = null;
    public isCustomProperty: boolean = false;
    public customPropertyAccessNote: string = null;
    public defaultUsers: UserItemModel[] = [];

    public daysWithTask: TasksObject[] = [];
    public daysWithReservations: ReservationsObject[] = [];
    public reservation: any = null;
    public taskRoutesInfo: TaskRoutesModel | null = null;
    public deletingTask: boolean = false;

    public focused: boolean = false;

    public get reservationDates(): string | null
    {
        if (!this.reservation)
        {
            return null;
        }

        const formattedArrivalDate = DateTime.fromISO(this.reservation.arrivalDate).toFormat('dd-MM-yyyy');
        const formattedDepartureDate = DateTime.fromISO(this.reservation.departureDate).toFormat('dd-MM-yyyy');

        return `${formattedArrivalDate} - ${formattedDepartureDate}`;
    }

    @Watch('form.actualWorkingTimeDisplay', { deep: true }) private convertToSeconds(): void
    {
        if (this.form.actualWorkingTimeDisplay)
        {
            const [hours, minutes] = this.form.actualWorkingTimeDisplay.split(':').map(Number);
            const seconds =  hours * 3600 + minutes * 60;

            if (this.form.actualWorkingTime !== seconds)
                this.form.actualWorkingTime = seconds;
        }
    }

    @Watch('form.reservationPublicId') private async onReservationPublicIdChange(): Promise<void>
    {
        if (this.isDeletedType) return;

        this.reservation = null;

        if (this.form.reservationPublicId)
        {
            this.reservation = await fetchReservation(this.form.reservationPublicId);
        }
    }

    public reservationNumber: string = null;

    @Watch('form.reservationPublicId')
    private async onReservationIdChange(): Promise<void>
    {
        if (this.isDeletedType) return;

        this.reservationNumber = null;

        if (!this.clipboardAvailable()) return;

        if (this.form.reservationPublicId)
        {
            const response = await fetchReservation(this.form.reservationPublicId);

            this.reservationNumber = response.avantioLocalizator;
        }
    }

    public getPhotos(): any[]
    {
        return this.form.photos.sort((a: FormModel['photos'][0], b: FormModel['photos'][0]) =>
        {
            if (!a.dateCreatedUtc && b.dateCreatedUtc) return 1;

            if (a.dateCreatedUtc && !b.dateCreatedUtc) return -1;

            if (a.dateCreatedUtc && b.dateCreatedUtc)
            {
                return new Date(b.dateCreatedUtc.toString()).getTime() - new Date(a.dateCreatedUtc.toString()).getTime();
            }

            return 0;
        });
    }

    public onPriorityChange(): void
    {
        if (this.isDeletedType) return;

        const { Urgent, High, Medium, Low, Watch } = PriorityEnum;
        let date = null;

        switch (this.form.priority)
        {
            case Urgent:
                date = DateTime.now().plus({ hours: 2 });
                break;
            case High:
                date = DateTime.now().plus({ hours: 4 });
                break;
            case Medium:
                date = DateTime.now().plus({ hours: 12 });
                break;
            case Low:
                date = DateTime.now().plus({ days: 1 });
                break;
            case Watch:
                date = DateTime.now().plus({ days: 1 });
                break;
        }

        this.form.dueDate = date;
    }

    @Watch('form.propertyPublicId') private async onPropertyPublicIdChange(): Promise<void>
    {
        if (this.isDeletedType) return;

        if (this.form.propertyPublicId)
        {
            this.property = (await PropertiesService.fetch(this.form.propertyPublicId)).result;

            this.propertyCityId = this.property.cityId;
            this.setDefalutPropertUsers();
            this.propertyNote = this.property.propertyNote;
        }
        else
            this.propertyNote = null;
    }

    @Watch('form.customPropertyPublicId') private async onCustomPropertyPublicIdChange(): Promise<void>
    {
        if (this.isDeletedType) return;

        if (this.form.customPropertyPublicId)
        {
            const property = (await PropertiesService.fetchCustomProperty(this.form.customPropertyPublicId)).result;

            this.customPropertyAccessNote = property.accessNote;
            this.propertyNote = property.propertyNote;
            this.isCustomProperty = true;
        }
        else
        {
            this.propertyNote = null;
            this.customPropertyAccessNote = null;
        }
    }

    @Watch('form.department', { immediate: false }) private setDefaultUsersAfterDepartmentChange(value: typeof DepartmentOptions | '', prevValue: typeof DepartmentOptions | ''): void
    {
        if (this.isDeletedType) return;

        this.setDefalutPropertUsers();

        if (value !== '' && prevValue !== '')
        {
            this.handleResetFormValuesAfterChangingDepartment();
        }

        if (value === DepartmentEnum.CustomerService)
        {
            this.addBOKTag();
        }
    }

    private async addBOKTag(): Promise<void>
    {
        const tags = await TasksTagsService.getAutocompleteList(TaskTagName.BOK);
        const tagBOK = tags.find((tag) => tag.name === TaskTagName.BOK);
        const tagsIds = this.form.tagsIds || [];

        if (!tagBOK || tagsIds.includes(tagBOK.id))
            return;

        this.form.tagsIds = [...tagsIds, tagBOK.id];
    }

    @Watch('form.additionalWageAmount')
    private onAdditionalWageChange(value: null | number | string, prevValue: null | number): void
    {
        if (!prevValue && prevValue !== 0)
            this.form.$errors.clear('additionalWageComment');

        if (!value && value !== null)
            this.form.additionalWageAmount = null;
    }

    public collapseSection = (section: string): void =>
    {
        this.collapse[section] = !this.collapse[section];
    };


    public get checklistIcon(): string
    {
        return TaskIcon(this.form.department);
    }

    public get isChecklistAvailable(): boolean
    {
        if (this.form.department !== DepartmentEnum.Cleaning && this.form.department !== DepartmentEnum.Maintenance || this.isCustomProperty)
            this.form.templateChecklistPublicId = null;

        if (this.form.department === DepartmentEnum.Cleaning && this.isCustomProperty)
            this.form.templateChecklistPublicId = null;

        if (this.isCustomProperty)
            return false;

        return this.form.department === DepartmentEnum.Cleaning || this.form.department === DepartmentEnum.Maintenance;
    }

    public get groups(): Option[]
    {
        return UserDepartmentOptions();
    }

    public get isRestFormVisible(): boolean
    {
        if (this.formType === "Deleted" && this.deletedForm.id)
            return true;

        return (this.form.department && this.form.propertyPublicId && !this.isCustomProperty) || (this.form.department && this.form.customPropertyPublicId && this.isCustomProperty);
    }



    private deletedForm: DeletedFormModel = {
        id: 0,
        publicId: '',
        department: '',
        priority: '',
        title: '',
        description: '',
        status: '',
        overallTime: '',
        dateStartedUtc: undefined,
        dateCompletedUtc: undefined,
        dueDateUtc: undefined,
        tags: [],
        assignedUsers: [],
        chats: [],
        createdNotes: [],
        photos: [],
        completedByUser: undefined,
        createdByUser: undefined,
        deletedByUser: undefined,
        reservation: undefined,
        property: undefined,
        checklist: undefined,
        createdFromNote: undefined
    };

    private form: FormType<FormModel> = Form.create<FormModel>({
        id: 0,
        publicId: '',
        propertyId: 0,
        propertyPublicId: null,
        customPropertyPublicId: null,
        costs: [],
        assignedUsersIds: [],
        issues: [],
        completedByUserId: null,
        createdByUserFullName: null,
        department: '',
        priority: PriorityEnum.Medium,
        templateChecklistId: null,
        templateChecklistPublicId: null,
        title: this.taskTitle,
        description: '',
        dateCompleted: null,
        dueDate: null,
        photos: [],
        status: StatusEnum.Created,
        reportLink: '',
        requestedByDepartment: null,
        dateStartedUtc: null,
        canStart: false,
        maintainerComment: null,
        taskChats: [],
        reservationPublicId: null,
        datePausedUtc: null,
        dateResumedUtc: null,
        overallTime: '00:00:00',
        comment: null,
        additionalWageAmount: null,
        additionalWageComment: null,
        tagsIds: [],
        completedByUserFullName: '',
        actualWorkingTime: null,
        actualWorkingTimeDisplay: null,
        guestReview: null,
        // Null (not []) means "picker hasn't been touched and hydration hasn't run" — the backend
        // treats null as "don't sync". Prevents wiping an existing task's activity list when a
        // partial PUT reaches the endpoint or when loadActivitiesFromAssignments fails silently.
        // Set to an array only after successful hydration or an actual picker change.
        activityPublicIds: null,
        activities: null
    });

    private permissions: TaskMetaPermissions = {
        canEdit: true,
        canComplete: true,
        canDelete: true,
        canEditFinishedTask: true,
        canEditPropActualWorkingTime: false,
        canViewChangeLog: true
    };

    private get publicId(): string
    {
        if (this.fromModal)
            return '';
        else if (this.publicIdProvided !== null)
            return this.publicIdProvided;
        else
            return String(this.$route.params.publicId || '');
    }

    private get formType(): string
    {
        if (this.$route.path.includes('delete'))
            return "Deleted";

        return "Task-form";
    }

    private get isDeletedType(): boolean
    {
        return this.formType === "Deleted";
    }

    public get isEditMode(): boolean
    {
        return this.publicId?.length > 0;
    }

    public get isViewForModal(): boolean
    {
        return (this.dateProvided || this.publicIdProvided || this.propertyProvided || this.reservationProvided);
    }

    public openAddCost(): void
    {
        const taskPublicId = this.publicIdProvided || this.publicId;

        if (!taskPublicId)
            return;

        const propertyPublicId = this.form.customPropertyPublicId || this.form.propertyPublicId || null;
        const isCustomProperty = !!this.form.customPropertyPublicId;

        this.$router.push({
            name: 'renter-tasks-management-add-cost',
            params: { publicId: taskPublicId },
            query: {
                propertyPublicId: propertyPublicId || undefined,
                isCustomProperty: isCustomProperty ? 'true' : 'false'
            }
        });
    }

    private get priorityOptions(): Option[]
    {
        return PriorityOptions();
    }

    private get departmentOptions(): Option[]
    {
        // const departments = DepartmentOptions().filter((department) =>
        // {
        //     if (this.isCustomProperty)
        //     {
        //         return department.value !== DepartmentEnum.Cleaning;
        //     }

        //     return true;
        // });

        return DepartmentOptions();
    }

    public get isTaskNotClosed(): boolean
    {
        return this.form.status !== StatusEnum.Closed;
    }

    public get status(): string
    {
        return StatusName(StatusEnum[this.form.status]);
    }

    public get getTotalWage(): number
    {
        let additionalWageAmount = this.form.additionalWageAmount;

        if (additionalWageAmount)
            additionalWageAmount = this.form.additionalWageAmount.toString().replace('e', '');

        return Math.floor((Number(this.property.cleaningWage) + Number(additionalWageAmount)) * 100) / 100;
    }

    public get getCorrectLabel(): string
    {
        let label = null;

        switch (this.form.department)
        {
            case DepartmentEnum.Cleaning:
                label = this.$t('[[[Wynagrodzenie za sprzątanie]]]');
                break;
            case DepartmentEnum.Maintenance:
                label = this.$t('[[[Wynagrodzenie za konserwację]]]');
                break;
            case DepartmentEnum.Inspection:
                label = this.$t('[[[Wynagrodzenie za inspecję]]]');
                break;
            default:
                label = this.$t('[[[Wynagrodzenie podstawowe]]]');
        }

        return label;
    }

    public get isWagerAvailable(): boolean
    {
        return this.$auth.state.identity.isAdmin || (this.form.department === DepartmentEnum.Cleaning && this.$auth.state.identity.departments.some(p =>  [DepartmentEnum.Coordinator, DepartmentEnum.MainCoordinator].includes(p)));
    }

    public onBOKselected(value: boolean): void
    {
        this.bokSelected = value;
    }

    public isDepartment(department: string): boolean
    {
        return DepartmentEnum[this.form.department] === DepartmentEnum[department];
    }

    public showTaskHistory(): void
    {
        this.$router.push({
            name: 'renter-tasks-history',
            params: { publicId: this.form.publicId }
        });
    }

    public formatReviewDate(date: string | null): string
    {
        if (!date) return '-';

        return DateTime.fromISO(date).toFormat('dd-MM-yyyy');
    }

    public channelLabel(channel: string | null): string
    {
        if (channel === 'airbnb2') return 'Airbnb';

        if (channel === 'bookingCom') return 'Booking.com';

        return channel ?? '-';
    }

    public channelBadgeClass(channel: string | null): string
    {
        if (channel === 'airbnb2') return 'bg-danger';

        if (channel === 'bookingCom') return 'bg-primary';

        return 'bg-secondary';
    }

    public mounted(): void
    {
        this.$events.$on('onCalendarMonthChange', this.handleSwitchCalendarMonth);

        this.checkBOKRole();
    }

    public unmounted(): void
    {
        this.$events.$off('onCalendarMonthChange', this.handleSwitchCalendarMonth);
    }

    public async created(): Promise<void>
    {
        this.form.propertyPublicId = this.propertyProvided || null;
        this.form.reservationPublicId = this.reservationProvided || null;
        this.form.dueDate = this.dateProvided || DateTime.now().plus({ hours: 2 });
        this.form.description = this.descriptionProvided || '';
        this.form.photos = this.photosProvided || [];
        this.form.department = DepartmentEnum[this.departmentProvided] || '';

        await this.form.ready([
            this.loadData(this.publicId)
        ]);

        if (!this.publicId && this.checkBOKRole())
        {
            this.form.requestedByDepartment = DepartmentEnumUsers.CustomerService;
        }

        if (this.form.actualWorkingTime)
        {
            const hours = String(Math.floor(this.form.actualWorkingTime / 3600)).padStart(2, '0');
            const minutes = String(Math.floor((this.form.actualWorkingTime % 3600) / 60)).padStart(2, '0');

            this.form.actualWorkingTimeDisplay = `${hours}:${minutes}`;
        }
    }

    // Chip cache stays in sync with the picker; the parallel activityPublicIds field is the
    // wire projection the backend consumes. The server derives the display title from activity
    // names on save (see UpsertTask.cs / TruncateForTitle) and returns it in the response, so
    // we deliberately do NOT mirror the title client-side — mirroring can diverge if an activity
    // is renamed in the dictionary between fetch and save. Clearing the 'title' error keeps the
    // validator's "required if no activities" rule from lingering visibly once a chip lands.
    public onActivitiesChanged(next: ActivityChip[]): void
    {
        this.form.activities = next;
        this.form.activityPublicIds = next.map(a => a.publicId);

        if (next.length > 0)
            this.form.$errors.clear('title');

        this.applyAnnualStocktakeTag();
    }

    private applyAnnualStocktakeTag(): void
    {
        if (this.isDeletedType)
            return;

        this.annualStocktakeTag.apply(this.form).catch(ex => this.$log.debug(ex));
    }

    // Assignments live behind a separate endpoint (owned by HIR-137). We hydrate the picker by
    // fetching them and projecting to the {publicId, name} chip shape — categoryName is populated
    // too so a chip renders its category tooltip even when the picker's category list hasn't been
    // fetched yet. On failure we leave the form fields as null (not []) — that's the sentinel the
    // save flow uses to mean "don't touch server-side assignments", protecting the user from
    // silently wiping their real assignment list because a fetch flaked.
    private async loadActivitiesFromAssignments(publicId: string): Promise<void>
    {
        try
        {
            const rows = await TaskActivityAssignmentsService.getList(publicId);
            const chips: ActivityChip[] = rows.map(r => ({
                publicId: r.activityPublicId,
                name: r.activityName,
                categoryPublicId: r.categoryPublicId,
                categoryName: r.categoryName
            }));

            this.form.activities = chips;
            this.form.activityPublicIds = chips.map(c => c.publicId);
        }
        catch (ex)
        {
            this.$log.debug(ex);
            // Deliberately keep both fields at their current (null) value — see the initializer
            // comment and TasksService.FormModel.activityPublicIds. Setting [] here would tell
            // the server "clear all assignments" on the next save, which is exactly the silent
            // wipe we're protecting against.
        }
    }

    private async loadData(publicId: string): Promise<boolean>
    {
        if (publicId == '')
            return true;

        const fetchMethod = this.formType === "Deleted" ? TasksService.fetchDeleted : TasksService.fetch;

        try
        {

            const response = await fetchMethod(publicId);

            if (this.formType === "Deleted")
            {
                this.deletedForm = response.result;
                this.collapse.details = true;
            }
            else
            {
                this.form.withData(response.result);
                await this.loadActivitiesFromAssignments(publicId);

                const hasBOKRole = this.checkBOKRole();

                let result = response.result;

                if (hasBOKRole)
                {
                    result = {
                        ...result,
                        requestedByDepartment: DepartmentEnumUsers.CustomerService
                    };
                }
            }


            this.$sitemap.extraCrumb = response.result.title;
            this.permissions = response.meta;
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message)
            });

            return false;
        }


        return true;
    }

    private checkBOKRole(): boolean
    {
        const roles = this.$store.state.auth.identity.departments || 'undefined - store nie ma takiej wartości';
        const hasBOKRole = roles.includes(DepartmentEnumUsers.CustomerService);

        if (hasBOKRole)
        {
            return true;
        }

        return false;
    }

    private handleSwitchCalendarMonth({month, year}: DateCalendarEmitProps): void
    {
        this.loadDataCalendarReservationAndTasksDays(month, year);
    }

    private async loadDataCalendarReservationAndTasksDays(month: number, year: number): Promise<void>
    {
        if (this.formType === "Deleted" )
            return;

        try
        {
            const publicId = this.isCustomProperty ? this.form.customPropertyPublicId : this.form.propertyPublicId;

            const data = (await TasksService.getCalendarTasksAndReservations(publicId, month, year)).result;

            this.daysWithTask = data.tasks;
            this.daysWithReservations = data.reservations;
        }
        catch (err)
        {
            this.$alert.error(this.$t('[[[Nie udało się pobrać danych odnośnie rezerwacji i zadań]]]'));
        }
    }

    private async onSubmit(route: string = null): Promise<void>
    {

        if (this.formType === "Deleted" )
            return;

        try
        {
            this.form.wait();

            if (!this.publicId)
            {
                if (this.form.additionalWageAmount !== null)
                {
                    if (this.checkIfWageIsCorrect())
                    {
                        return;
                    }
                }

                if (this.isCustomProperty)
                {
                    this.form.propertyPublicId = null;
                }
                else
                {
                    this.form.customPropertyPublicId = null;
                }

                const response = await TasksService.create(this.form.data());

                response.result.photos = await this.uploadPhotos(this.form.photos);

                await TasksService.updatePhotos(response.result.publicId, response.result.photos);

                this.form.withData(response.result);

                if (!this.fromModal && !route && this.$route.name === 'renter-tasks-add')
                    this.$alert.success(this.$t('[[[Zadanie zostało dodane.]]]'));
                else
                    this.$alert.success(this.taskCreatedAlert.content(
                        response.result.publicId,
                        this.$t('[[[Zadanie zostało dodane.]]]'),
                        this.$t('[[[Przejdź do zadania]]]')
                    ), { timeout: 5_000, closeOnClick: true });

                this.$emit('taskCreated', response.result.publicId);
            }
            else
            {
                if (this.form.additionalWageAmount !== null)
                {
                    if (this.checkIfWageIsCorrect())
                    {
                        return;
                    }
                }

                this.form.photos = await this.uploadPhotos(this.form.photos);
                await TasksService.update(this.publicId, this.form.data());

                this.$alert.success(this.$t('[[[Zadanie zostało zaktualizowane.]]]'));
            }

            if (this.fromModal)
            {
                this.$emit('close');

                return;
            }

            if (!route && this.$route.name === 'renter-tasks-add')
                this.$router.replace({ name: 'renter-tasks-edit', params: { publicId: this.form.publicId } });

            if (route)
            {
                if (!this.isViewForModal)
                    this.$router.back();
                else
                    this.$emit('close');
            }
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message),
                422: (ex: any) => this.form.$errors.record(ex.data.errors)
            });

            this.$alert.error(this.$t('[[[Formularz zadania nie jest poprawny.]]]'));

            for (const section in this.collapse)
            {
                this.collapse[section] = false;
            }
        }
        finally
        {
            this.form.continue();
        }
    }

    public async handleClickCloseTask(): Promise<void>
    {
        if (this.formType === "Deleted" )
            return;

        try
        {
            const task = this.form.data();

            task.status = StatusEnum.Closed;
            await TasksService.update(task.publicId, task);

            this.form.status  = StatusEnum.Closed;
        }
        catch (ex)
        {
            this.$alert.error(this.$t('[[[Nie udało się zmienić statusu zadania]]]'));
            this.$log.debug(ex);
        }
    }

    public async handleClickDeleteTask(): Promise<void>
    {
        if (this.formType === "Deleted" )
            return;

        try
        {
            const routesInfo = await TasksService.getRoutes(this.form.publicId);

            if (routesInfo.routeNames && routesInfo.routeNames.length > 0)
            {
                this.taskRoutesInfo = routesInfo;

                const modalRef: any = this.$refs.routesModal;

                if (modalRef)
                {
                    modalRef.show();

                    return;
                }
            }

            await this.performDelete();
        }
        catch (ex)
        {
            this.$log.debug(ex);
            await this.performDelete();
        }
    }

    private async performDelete(): Promise<void>
    {
        this.deletingTask = true;

        try
        {
            await TasksService.remove(this.form.publicId);
            this.$router.back();
            this.$alert.success(this.$t('[[[Zadanie zostało usunięte]]]'));
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message)
            });
        }
        finally
        {
            this.deletingTask = false;
            this.taskRoutesInfo = null;
        }
    }

    private async confirmDeleteWithRoutes(): Promise<void>
    {
        if (!this.taskRoutesInfo)
        {
            return;
        }

        const lat = typeof this.taskRoutesInfo.latitude === 'string'
            ? parseFloat(this.taskRoutesInfo.latitude)
            : this.taskRoutesInfo.latitude;
        const lng = typeof this.taskRoutesInfo.longitude === 'string'
            ? parseFloat(this.taskRoutesInfo.longitude)
            : this.taskRoutesInfo.longitude;

        if (isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0)
        {
            return;
        }

        this.deletingTask = true;

        try
        {
            await TasksService.remove(this.form.publicId);

            this.closeRoutesModal();

            const dateUtc = this.form.dueDate
                ? this.form.dueDate.toISO()
                : DateTime.utc().toISO();

            this.$router.push({
                name: 'renter-drivers-routes-map',
                query: {
                    date: dateUtc,
                    lat: lat.toString(),
                    lng: lng.toString()
                }
            }).catch(err =>
            {
                this.$log.debug(err);
            });

            this.$alert.success(this.$t('[[[Zadanie zostało usunięte]]]'));
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message)
            });
        }
        finally
        {
            this.deletingTask = false;
            this.taskRoutesInfo = null;
        }
    }

    private closeRoutesModal(): void
    {
        const modalRef: any = this.$refs.routesModal;

        modalRef.hide();
        this.taskRoutesInfo = null;
    }

    public setDefalutPropertUsers(): void
    {
        if (this.formType === "Deleted" )
            return;

        if (this.property)
        {
            switch (this.form.department)
            {
                case DepartmentEnum.Cleaning:
                    this.defaultUsers = this.property.defaultCleaningUsers;
                    break;
                case DepartmentEnum.Maintenance:
                    this.defaultUsers = this.property.defaultMaintenanceUsers;
                    break;
                case DepartmentEnum.Inspection:
                    this.defaultUsers = this.property.defaultInspectionUsers;
                    break;
                case DepartmentEnum.CustomerService:
                    this.defaultUsers = this.property.defaultCustomerServiceUsers;
                    break;
                case DepartmentEnum.OwnerService:
                    this.defaultUsers = this.property.defaultOwnerServiceUsers;
                    break;
                default:
                    this.defaultUsers = [];
                    this.form.assignedUsersIds = [];
                    break;
            }
        }
    }

    public goBack(event?: Event): void
    {
        if (event)
        {
            event.preventDefault();
            event.stopPropagation();
        }

        try
        {
            const currentRoute = this.$router.currentRoute.value.name;

            if (currentRoute === 'renter-tasks-add')
            {
                this.$router.push({ name: 'renter-tasks' }).catch(() =>
                {
                    if (window.history.length > 1)
                        window.history.back();
                    else
                        window.location.href = '/app/tasks';
                });
            }
            else
            {
                this.$router.back();
            }
        }
        catch (error)
        {
            if (window.history.length > 1)
            {
                window.history.back();
            }
            else
            {
                window.location.href = '/app/tasks';
            }
        }
    }

    private async uploadPhotos(photosList: Array<any>): Promise<Resource[]>
    {
        const photos = photosList.filter(photo => photo.publicId);
        const photosToUpload = photosList.filter(photo => photo.upload);
        const responses = await Promise.all(
            photosToUpload.map(photo => TasksService.uploadPhoto(photo.upload, "default"))
        );

        return [...photos, ...responses];
    }

    private checkIfWageIsCorrect(): boolean
    {
        const value = this.form.additionalWageAmount;

        if (value === '' || value.toString().includes('e'))
        {
            const errorText = this.$t('[[[W polu możemy umieszczać jedynie cyfry]]]');

            this.form.$errors.record({ additionalWageAmount: [ errorText ] });

            return true;
        }

        if (Number(value) < 0)
        {
            const errorText = this.$t('[[[Kwota dodatkowego wynagrodzenia nie może być ujemna]]]');

            this.form.$errors.record({ additionalWageAmount: [ errorText ] });

            return true;
        }

        return false;
    }

    private handleResetFormValuesAfterChangingDepartment(): void
    {
        const form = this.form.data();

        this.form.reset();

        this.form.id = form.id;
        this.form.publicId = form.publicId;
        this.form.department = form.department;
        this.form.title = form.title;
        this.form.propertyId = form.propertyId;
        this.form.propertyPublicId = form.propertyPublicId;
        this.form.description = form.description;

        this.form.tagsIds = form.tagsIds;
        this.form.reservationPublicId = form.reservationPublicId;
        this.form.photos = form.photos;
        this.form.taskChats = form.taskChats;
        this.form.assignedUsersIds = [];
        this.form.createdByUserFullName = form.createdByUserFullName;

    }

    private chatsVisible: boolean = false;
    public currentChatPublicId: string = '';
    public savingComment: boolean = false;
    public commentError: string = null;

    public statusArchived(status: string): boolean
    {
        return ChatStatusEnum[status] === ChatStatusEnum.Archival;
    }


    protected fetchProperty = fetchProperty;
    protected searchProperty = searchProperty;
    protected fetchPropertyV2 = fetchPropertyV2;
    protected searchPropertyV2 = searchPropertyV2;
    protected fetchCustomProperty = fetchCustomProperty;
    protected searchCustomProperty = searchCustomProperty;
    protected searchChecklist = searchChecklist;
    protected fetchChecklist = fetchChecklist;
    protected searchReservation = searchReservation;
    protected fetchReservation = fetchReservation;
    protected fetchTaskTag = TasksTagsService.fetchAutocompleteModel;
    protected getTasksTags = TasksTagsService.getAutocompleteList;

    public async saveComment(): Promise<void>
    {
        if (!this.publicId || this.isDeletedType)
            return;

        if (!this.form.comment || this.form.comment.trim() === '')
        {
            this.commentError = this.$t('[[[Pole nie może być puste]]]');

            return;
        }

        try
        {
            this.savingComment = true;
            this.commentError = null;

            await TasksService.updateComment(this.publicId, { comment: this.form.comment });

            this.$alert.success(this.$t('[[[Komentarz został zapisany]]]'));
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.commentError = ex.message || this.$t('[[[Nie udało się zapisać komentarza]]]'),
                422: (ex: any) =>
                {
                    if (ex.data?.errors?.Comment)
                        this.commentError = ex.data.errors.Comment[0];
                    else
                        this.commentError = this.$t('[[[Nie udało się zapisać komentarza]]]');
                }
            });

            this.$log.debug(ex);
        }
        finally
        {
            this.savingComment = false;
        }
    }
}
</script>
<style lang="scss">
.modal-footer-buttons{
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 5;
}

.action-buttons-container {
    .rounded-pill .btn {
        @media (max-width: map-get($grid-breakpoints, 'lg')) {
            display: none;
        }
    }
}



</style>

<style lang="scss" scoped>
    .bok-template {
        padding-left: 1.5rem !important;
    }
</style>
